import { createApiService } from "@/core/api/apiService";
import type { StripeConnectionDto, StripeFinanceSummaryDto } from "../types/stripeTypes";

export function createStripeApiService() {
  const api = createApiService("businesses");
  return {
    getByBusinessId: (businessId: string, signal?: AbortSignal) =>
      api.get<StripeConnectionDto>(`/${businessId}/stripe`, { signal }),
    startOnboarding: (businessId: string, dto: { location_id: string; channel: "web" | "native" }, signal?: AbortSignal) =>
      api.post<{ onboarding_url: string }>(`/${businessId}/stripe/onboarding`, dto, { signal }),
    getFinances: (businessId: string, signal?: AbortSignal) =>
      api.get<StripeFinanceSummaryDto>(`/${businessId}/stripe/finances`, { signal }),
  };
}
export const stripeApiService = createStripeApiService();
